import Vue from 'vue'
import VueRouter from 'vue-router'
import ObjectListPage from "@/pages/ObjectListPage";
import ObjectPage from "@/pages/ObjectPage";
import ObjectMapPage from "@/pages/ObjectMapPage";
import ObjectGroupListPage from "@/pages/ObjectGroupListPage";
import NotFoundComponent from "@/pages/NotFoundComponent";

Vue.use(VueRouter)

const routes = [
    /*{
        path: '/',
        name: 'object-list',
        component: ObjectListPage,
    },*/
    {
        path: '/:user_id/:link/group',
        name: 'object-group-list',
        component: ObjectGroupListPage,
    },
    {
        path: '/:user_id/:link/object/:id',
        name: 'object',
        component: ObjectPage
    },
    {
        path: '/:user_id/:link/map',
        name: 'object-map',
        component: ObjectMapPage,
    },
    {
        path: '/:user_id/:link/:type?',
        name: 'object-list',
        component: ObjectListPage,
        props: true
    },
    {
        path: '*',
        component: NotFoundComponent
    },
]

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior () {
        return {x: 0, y: 0}
    }
})

export default router;

